export default "__VITE_ASSET__6b89557e__"